import { invokeAmTpDemoAiTask } from './invokeAmTpDemoAiTask';
import { TAmDemoAiContextFor } from './types';

/** Returns the roll-forward verdict, the question the modal asks, and the recommendation. */
export async function evaluateAmTpDemoRollForward(
  context: TAmDemoAiContextFor<'rollforward.evaluate'>
) {
  return invokeAmTpDemoAiTask('rollforward.evaluate', context);
}
